import React, { useEffect, useState, useMemo } from 'react'
import { Route, Routes} from 'react-router-dom';

import { Project } from '../containers';
import * as Pages from '../pages';

const MyRoutes = () => {
  const pageMinHeight = '75vh'
  const currentPath = window.location.pathname;


  const pagesRoute = useMemo(() => [
    { name: 'about', path: '/about', element: <Pages.About style={{ minHeight: pageMinHeight }} /> },
    { name: 'contact', path: '/contact', element: <Pages.Contact style={{ minHeight: pageMinHeight }} /> },
    { name: 'home', path: '/', element: <Pages.Home sx={{ minHeight: pageMinHeight }} /> },
    { name: 'projects', path: '/projects', element: <Pages.Projects style={{ minHeight: pageMinHeight }} /> },
    { name: 'services', path: '/services', element: <Pages.Services style={{ minHeight: pageMinHeight }} /> },
    { name: 'career', path: '/career', element: <Pages.Career style={{ minHeight: pageMinHeight }}/>}
  ], [pageMinHeight]);

  const subPageRoute = useMemo(() => [
    { name:'careeroffers', path:'/career/offers', element: <Pages.Career /> }
  ],[])

  const projectsRoute = useMemo(() => [
    { name: 'Celetse Residence', path: '/projects/celeste-residence', element: <Project id='celeste' /> },
    { name: 'Hive II', path: '/projects/hive', element: <Project id='hive' /> },
    { name: "Jackson's House", path: '/projects/jackson-house', element: <Project id='jackson' /> },
    { name: 'The New Chapter', path: '/projects/the-new-chapter', element: <Project id='tnc' /> },
    { name: 'Vine', path: '/projects/vine', element: <Project id='vine' /> },
    { name: 'Waterfront Eye Wear', path: '/projects/waterfront-eye-wear', element: <Project id='waterfront' /> },
    { name: 'Madrona', path: '/projects/madrona', element: <Project id='madrona' /> },
  ], []);



  const [validRoute, setValidRoute] = useState(false);
  
  //add new routes here to make it valid
  useEffect(() => {
    const isRouteValid = 
      projectsRoute.some((project) => project.path === currentPath) 
    || pagesRoute.some((page) => page.path === currentPath) 
    || subPageRoute.some((subpage) => subpage.path === currentPath);
    

    setValidRoute(isRouteValid);

  }, [currentPath, pagesRoute, projectsRoute, subPageRoute]);
  

  return (
    <Routes>
      {validRoute ? (
        <>
        {pagesRoute.map((page, index) => (
          <Route 
            key={index}
            path={page.path}
            element={page.element}
          />
        ))}
        {subPageRoute.map((page, index) => (
          <Route 
            key={index}
            path={page.path}
            element={page.element}
          />
        ))}
        {projectsRoute.map((project, index) => (
          <Route 
            key={index}
            path={project.path}
            element={project.element}
          />
        ))}
        </>
      ) : (
        <Route 
          path='*'
          element={<Pages.NotFound />}
        />
      )
    }
    </Routes>
  )
}

export default MyRoutes